import { iPeriodResponse } from "../interfaces/interfaces";
import { getHumanDate } from "../utils/helpers";

export class Period {
	number: number;
	isFinished: boolean;
	endTime: {
		ts: number,
		formatted: string,
	};


	constructor (periodResponse: iPeriodResponse) {
		this.number = periodResponse.num;
		this.isFinished = periodResponse.finished;
		this.endTime = {
			ts: periodResponse.end_time,
			formatted: getHumanDate(periodResponse.end_time, 'YYYY-MM-DD hh:mm'),
		};
	}
}